<template>
    <div class="add-teacher-container" id="addTeacherForm">
        <div class="add-teacher-wrapper">
            <div :class="showFormClass">
                <div class="add-teacher-btn">
                    <button class="solid-btn outline" @click="!active? newTeacherModal=true : null" style="text-transform: initial !important;">
                        Add Teacher(s)<i class="fa fa-plus" aria-hidden="true"></i>
                    </button>
                </div>
                <div class="add-teacher-form" v-loading="loading">
                    <div class="add-teacher-form-wrapper">
                        <h5 class="title-5">Teacher Information </h5>
                        <div class="add-teacher-row cols-3">
                            <div class="form-element">
                                <label>First Name *</label>
                                <input :class="inputErrorClass(payloadErrors.name)" v-model="name"
                                       placeholder="Write Here" type="text">
                            </div>
                            <div class="form-element">
                                <label>Last Name *</label>
                                <input :class="inputErrorClass(payloadErrors.lastName)" v-model="lastName"
                                       placeholder="Write Here" type="text">
                            </div>
                            <div class="form-element right">
                                <label>Email *</label>
                                <input :class="inputErrorClass(payloadErrors.email)" v-model="email"
                                       placeholder="Write Here" type="text">
                            </div>
                        </div>
                        <div class="add-teacher-row cols-3">
                            <div class="form-element">
                                <label>School Name *</label>
                                <input :class="inputErrorClass(payloadErrors.school)" v-model="school"
                                       placeholder="Write Here" type="text">
                            </div>
                            <div class="form-element">
                                <label>Grade *
                                    <poptip word-wrap width="200" content="We tailor each box to include core supplies that are grade level appropriate. Please indicate the grade level that best matches this teacher's classroom.">
                                        <i class="fa fa-info-circle" aria-hidden="true" style="cursor: pointer"></i>
                                    </poptip>
                                </label>
                                <!--<select class="form-control select-box" :class="payloadErrors.grade? 'red-hover':''"-->
                                        <!--id="grade">-->
                                    <!--<option value="null">Select Grade</option>-->
                                    <!--<template v-for="grade in grades">-->
                                        <!--<option :value="grade.slug">{{grade.name}}</option>-->
                                    <!--</template>-->
                                <!--</select>-->
                                <el-select v-model="grade" filterable placeholder="Select State">
                                    <el-option
                                        v-for="item in grades"
                                        :key="item.slug"
                                        :label="item.name"
                                        :value="item.slug">
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="form-element right">
                                <label>District *</label>
                                <input :class="inputErrorClass(payloadErrors.district)" v-model="district"
                                       placeholder="Write Here" type="text">
                            </div>
                        </div>
                        <div class="add-teacher-row cols-3">
                            <div class="form-element">
                                <label>State *</label>
                                <el-select v-model="state" filterable placeholder="Select State">
                                    <el-option
                                        v-for="item in states"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="form-element">
                                <label>City *</label>
                                <input :class="inputErrorClass(payloadErrors.city)" v-model="city"
                                       placeholder="Write Here" type="text">
                            </div>
                            <div class="form-element right">
                                <label>ZIP Code *</label>
                                <input :class="inputErrorClass(payloadErrors.zip)" v-model="zip"
                                       placeholder="Write Here" type="number">
                            </div>
                        </div>
                        <div class="add-teacher-row amount">
                            <div class="form-element">
                                <h5 class="title-5">Amount of funding</h5>
                            </div>
                            <div class="form-element right">
                                <poptip word-wrap width="200" content="By adding a teacher not currently listed on GiftATeacher.org you are agreeing to fund the cost of their two Classroom Supply Boxes in full.">
                                    <input class="input-field" readonly :value="amount" placeholder="Write Here" type="text">
                                </poptip>
                            </div>
                        </div>
                        <div class="teacher-form-buttons">
                            <div class="form-button">
                                <button class="solid-btn outline" @click="cancel">
                                    Cancel<i class="fa fa-times" aria-hidden="true"></i>
                                </button>
                            </div>
                            <div class="form-button right">
                                <button class="solid-btn" @click="addTeacher">
                                    Add an unlisted Teacher<i class="fa fa-plus" aria-hidden="true"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Modal
            v-model="newTeacherModal"
            :footer-hide="true"
            class-name="vertical-center-modal medium-size"
            :mask-closable="true">
            <div class="text-center" style="width: 300px; margin: auto;">
                <h5 class="title-5 text-center">I Would like to</h5>
                <br>
                <a :href="teacherIndexRoute" class="solid-btn mt-3">Browse Teachers</a>
                <br>
                <button class="solid-btn mt-3" style="margin-top: 20px" @click="openForm">Fund an unlisted Teacher</button>
            </div>
        </Modal>
        <Modal
            v-model="teacherAlreadyExistsModal"
            :footer-hide="true"
            class-name="vertical-center-modal medium-size"
            :mask-closable="true">
            <div class="text-center" style="width: 300px; margin: auto;">
                <h5 class="title-5 text-center">Teacher already exists</h5>
                <br>
                <p style="font-size: 18px">The teacher you want to add already exists in our records.</p>
                <br>
                <button class="solid-btn mt-3" style="margin-top: 20px" @click="teacherAlreadyExistsModal=false">
                    OK
                </button>
            </div>
        </Modal>
    </div>
</template>

<script>
    export default {
        mounted() {
            let vm = this;
            window.$('#grade').change(function () {
                vm.grade = $(this).val();
            });

            if(Boolean(sessionStorage.openAddTeacher)){
                this.openForm();
                sessionStorage.removeItem('openAddTeacher');
            }
        },
        props: {
            cartId: {
                required: true,
            }
        },
        data() {
            return {
                name: "",
                lastName: "",
                email: "",
                school: "",
                grade: "",
                district: "",
                state: "",
                city: "",
                zip: "",
                amount: "$"+(App.goal_amount/100).toFixed(2),

                loading: false,
                active: false,
                validating: false,
                newTeacherModal: false,
                teacherAlreadyExistsModal:false,

                fundraiser_id:null,
                teacher_id:null,
                fundraiser_slug:null,
            }
        },
        computed: {
            teacherIndexRoute(){
                return window.App.globalData.routes.teachers_index;
            },
            showFormClass() {
                return this.active ? "add-teacher-block active" : "add-teacher-block";
            },
            payloadErrors() {
                if (this.validating) {
                    if (this.grade === "") {
                        $('.el-select')[0].className = "el-select red-hover";
                    } else {
                        $('.el-select')[0].className = "el-select";
                    }

                    if (this.state === "") {
                        $('.el-select')[1].className = "el-select red-hover";
                    } else {
                        $('.el-select')[1].className = "el-select";
                    }

                }

                return {
                    name: this.validating && this.name.trim() === "",
                    lastName: this.validating && this.lastName.trim() === "",
                    email: this.validating && (this.email.trim() === "" || !this.validateEmail(this.email)),
                    school: this.validating && this.school.trim() === "",
                    grade: this.validating && this.grade.trim() === "",
                    district: this.validating && this.district.trim() === "",
                    state: this.validating && this.state === "",
                    city: this.validating && this.city.trim() === "",
                    zip: this.validating && this.zip.trim() === "",
                };
            },
            payload() {
                return {
                    name: this.name,
                    lastName: this.lastName,
                    email: this.email,
                    school: this.school,
                    grade: this.grade,
                    district: this.district,
                    state: this.state,
                    city: this.city,
                    zip: this.zip,
                };
            },
            item(){
                let stateName = '';
                this.states.forEach(state=>{
                    if(state.value === this.state){
                        stateName = state.label;
                    }
                });

                return {
                    "name": this.name + ' ' + this.lastName ,
                    "grade": window.App.globalData.grades[this.grade].name,
                    "state": stateName,
                    "school": this.school,
                    "district": this.district,
                    "goal_amount":  (App.goal_amount/100),
                    "fundraiser_id": this.fundraiser_id,
                    "fundraiser_slug": this.fundraiser_slug,
                    "raised_amount": 0,
                    "new_teacher_id": this.teacher_id,
                    "current_donation": (App.goal_amount/100),
                };
            },
            grades() {
                return window.App.globalData.grades;
            },
            states() {
                return window.App.globalData.states.map(item => {
                    return {
                        label: item.name,
                        value: item.slug,
                    }
                });
            },
        },
        methods: {
            openForm() {
                this.newTeacherModal = false;
                this.active = true;
                setTimeout(()=>{
                    $('html, body').animate({
                        scrollTop: $("#addTeacherForm").offset().top
                    }, 1000);
                },500);
                // console.log(this.$root.$refs.kinf.user );
                // if (this.$root.$refs.kinf.user !== null){this.active = true; return;}
                // kinfEvents.$emit('OpenLogin');
            },
            inputErrorClass(hasError) {
                return hasError ? "input-field red-hover" : "input-field";
            },
            cancel() {
                this.active = false;
                this.reset();
            },
            reset() {
                this.name = "";
                this.lastName = "";
                this.school = "";
                this.grade = "";
                this.state = "";
                this.city = "";
                this.zip = "";
                this.validating = false;
            },
            addTeacher() {
                if (this.validate()) {
                    let route = window.App.globalData.routes.add_teacher;
                    this.loading = true;
                    axios.post(route,this.payload).then(response=>{
                        if(!response.data.data.new_teacher_id){

                            this.teacherAlreadyExistsModal=true;
                            this.loading=false;
                            return;

                        }

                        this.loading = false;
                        this.fundraiser_id = response.data.data.fundraiser_id;
                        this.teacher_id = response.data.data.new_teacher_id;
                        this.fundraiser_slug = response.data.data.item.fundraiser_slug;

                        this.sendAddToCart();
                    }).catch(e=>{

                        this.loading = false;
                        console.log(e);
                        this.$notify({
                            title: 'Error',
                            message: e.response.data.response.message,
                            type: 'error'
                        });
                        this.loading = false;
                    });

                }
            },
            validate() {
                let hasError = false;
                this.validating = true;
                for (let x in this.payloadErrors) {
                    if (this.payloadErrors[x]) {
                        hasError = true;
                    }
                }
                return !hasError;
            },
            validateEmail(mail) {
                if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
                    return true;
                }
                return false
            },
            sendAddToCart(){
				if (this.cartId === null) {
					this.createCart();
					return;
				}
				
            	this.loading=true;
                let route = window.App.globalData.routes.add_item_to_cart.replace('ID',this.cartId);
                axios.post(route,{
                    amount: (App.goal_amount/100),
                    fundraiser_id: this.fundraiser_id,
                    new_teacher: this.teacher_id,
                    item: this.item,
                }).then(response=>{
                    // console.log(response);
                    this.loading = false;
                    this.active = false;
                    this.reset();
                    this.$notify({
                        title: 'Success',
                        message: response.data.response.message,
                        type: 'success'
                    });
                    kinfEvents.$emit('refreshCart');

                }).catch(e => {
                    console.log(e)
                    this.loading = false;
                    this.$notify({
                        title: 'Error',
                        message: e.response.data.response.message,
                        type: 'error'
                    });

                });
            },
            createCart() {
                let createRoute = window.App.globalData.routes.create_cart;
                axios.post(createRoute).then(response => {
                    // this.cartId = response.data.data.cart_id;
                    kinfEvents.$emit('CartCreated', response.data.data.cart_id);
                    window.localStorage.setItem('cartId', response.data.data.cart_id);
                    setTimeout(() => {
                        this.sendAddToCart(response.data.data.cart_id);
                    }, 500)
                }).catch(e => console.log(e));
            },

        }
    }
</script>

<style lang="less">
    .el-select {
        width: 100%;
        border: 2px solid #e2e7ee;
        border-radius: 10px;
        padding: 12px;
        font-family: "Rubik-Regular";
        font-size: 18px;
        color: #98a4bb;
        height: 55px;
    }

    .el-select.red-hover {
        border-color: #fb202d !important;
    }

    .el-select.red-hover {
        border-color: #fb202d !important;
    }

    .el-input__inner {
        border: 0px !important;
        margin-top: -5px !important;
        font-family: "Rubik-Regular" !important;
        font-size: 18px !important;
        padding: 0 !important;
        color: #98a4bb !important;
    }

    .sbHolder.red-hover {
        border-color: #fb202d !important;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        /* display: none; <- Crashes Chrome on hover */
        -webkit-appearance: none;
        margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
    }

    .el-select-dropdown {
        border: 2px solid #c8d1d9 !important;
        border-radius: 10px;
    }

    .el-select-dropdown:before {
        top: -11px;
        left: 50%;
        content: "";
        background: url(/images/select-arrow.png?a52eb7dcd2a9d932dc3246a294fe0dd2) no-repeat left;
        width: 18px;
        height: 11px;
        position: absolute;
        z-index: 999;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
    }

    .el-select-dropdown__item {
        outline: none;
        padding: 15px 20px 12px;
        font-size: 18px;
        line-height: 23px;
        color: #4a4a4a;
        text-decoration: none;
        font-family: "Rubik-Regular";
        border-top: 1px solid #e2e7ee;
        height: auto !important;
    }

    .el-select-dropdown__list {
        padding: 0 !important;
    }

    .el-select {
        padding: 0 !important;
    }

    .el-input {
        top: 10px;
        padding-left: 10px;
    }

    .el-select-dropdown__item:first-child {
        border-top: 0px;
        border-radius: 10px 10px 0px 0px;
    }

    .el-select-dropdown__item:last-child {
        border-top: 0px;
        border-radius: 0px 0px 10px 10px;
    }

    .el-select-dropdown__item:hover {
        background: #d9232e;
        color: #fff;
    }

    .el-select-dropdown__item.hover {
        background: #d9232e;
        color: #fff;
    }

    .popper__arrow {
        display: none !important;
    }

    .vertical-center-modal{
        display: flex;
        align-items: center;
        justify-content: center;


        .ivu-modal {
            top: 0;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/js/views/checkout/components/index/AddTeacherComponent.vue